import React, { useState } from "react";
import InputComponent from "../input/InputComponent";
import PhoneInputComponent from "../input-phone-component/PhoneInputComponent";
import styles from "../../components/live-support/liveSupportComponent.module.scss";
import SupportServices from "./services/SupportService";
import { setCookie } from "../../api/utils/utils";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

interface Props {
  setLoggedIn: (loggedIn: boolean) => void;
  setIsLiveChat: (isLiveChat: boolean) => void;
}

const LiveChatForm = ({ setLoggedIn, setIsLiveChat }: Props) => {
  const [formData, setFormData] = useState({
    guest_name: "",
    guest_email: "",
    guest_phone: "",
  });
  const [errors, setErrors] = useState({
    guest_name: "",
    guest_email: "",
    guest_phone: "",
  });
  const [selectedCode, setSelectedCode] = useState("");
  const translations = useSelector(
    (state: RootState) => state.translations?.data
  );

  const handleSubmit = () => {
    const payload = {
      guest_name: formData.guest_name,
      guest_email: formData.guest_email,
      guest_phone: formData.guest_phone
        ? `${selectedCode}${formData.guest_phone}`
        : "",
    };
    SupportServices.registerUserForChat(payload)
      .then((res) => {
        setCookie("bsc-guest-chat-id", res.data.chat_id);
        setCookie("bsc-guest-token-chat", res.data.guest_token);
        setLoggedIn(false);
        setIsLiveChat(true);
      })
      .catch((err) => setErrors(err?.response?.data?.errors));
  };

  return (
    <form className={styles.supportForm}>
      <span className={styles.timestamp}>{translations?.start_chat}</span>
      <InputComponent
        label={translations?.email}
        type="text"
        name="guest_email"
        value={formData.guest_email}
        onChange={(e) =>
          setFormData({ ...formData, guest_email: e.target.value })
        }
        error={errors?.guest_email}
      />
      <InputComponent
        label={translations?.name}
        type="text"
        name="guest_name"
        value={formData.guest_name}
        onChange={(e) =>
          setFormData({ ...formData, guest_name: e.target.value })
        }
        error={errors?.guest_name}
      />
      <PhoneInputComponent
        label={translations?.phone_number}
        id="guest_phone"
        name="guest_phone"
        value={formData.guest_phone}
        onChange={(e) =>
          setFormData({
            ...formData,
            guest_phone: e.target.value,
          })
        }
        selectedCode={selectedCode}
        onCodeChange={(e) => setSelectedCode(e.target.value)}
        error={errors?.guest_phone}
      />
      <button
        type="submit"
        className={styles.startChatBtn}
        onClick={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        Çata başlayın
      </button>
    </form>
  );
};

export default LiveChatForm;
